module.exports = __webpack_public_path__ + "img/2.2d81d230.png";